import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { IEBillLocation } from '@ruby/shared/models/ebill/ebil.interface';

@Component({
  selector: 'ng-ebill-notes-dialog',
  templateUrl: './ebill-notes.dialog.html',
  styleUrls: ['./ebill-notes.dialog.scss']
})
export class EBillNotesDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: {
    title: string;
    locations: Array<IEBillLocation>;
    description: Array<string>;
    isAdmin?: boolean;
    type?: 'Help' | 'Notes';
  }) { }
}
